import { axiosSSO } from 'config';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { fetchAuthWithoutValidateStatus } from 'services/authService';
import { clearAxiosAdapterCache } from 'utils/cacheHelper/axiosCacheAdapter';
import notificationsHandler from 'utils/notificationsHandler';
import { sendLocalStorageSignal } from 'utils/sessionStorageHandlers';
import { authActions } from './authSlice';

function* getUserData() {
    try {
        const data = yield call(fetchAuthWithoutValidateStatus);
        let { username, roles, userId, email, userLocationFeature } = data || {};
        if (roles?.length) {
            const user = { username, roles, id: userId, email, userLocationFeature };
            yield put(authActions.setUser(user));
        }
    } catch (err) {
        yield call(notificationsHandler, {
            err,
            title: 'Error getting user data!',
        });
    }
    yield put(authActions.setIsUserDataRequested(true));
}

function* handleUnauthorized() {
    try {
        yield call(fetchAuthWithoutValidateStatus);
    } catch (err) {
        yield call(logout);
    }
}

function* logout() {
    try {
        yield call(axiosSSO.post, '/logout');
        sendLocalStorageSignal('UserLoggedOut');
        yield put(authActions.setUser(null));
        sessionStorage.clear();
        yield clearAxiosAdapterCache();
    } catch (err) {
        yield call(notificationsHandler, {
            err,
            title: 'Logout error.',
        });
    }
}

function* onGetUserData() {
    yield takeLatest(authActions.getUserData.type, getUserData);
}

function* onHandleUnauthorized() {
    yield takeEvery(authActions.handleUnauthorized.type, handleUnauthorized);
}

function* onLogoutStart() {
    yield takeLatest(authActions.logoutStart.type, logout);
}

export function* authSaga() {
    yield all([call(onGetUserData), call(onLogoutStart), call(onHandleUnauthorized)]);
}
